<template>
  <div>
    <!-- Vendas Operadores Table -->
    <vendas-operadores-table
      ref="vendasOperadoresTableRef">
    </vendas-operadores-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const vendasOperadoresTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (vendasOperadoresTableRef.value) {
    await vendasOperadoresTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('VendasOperadoresPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('VendasOperadoresPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
